import * as React from 'react';
import Paragraph from 'antd/lib/typography/Paragraph';
import Modal from 'antd/lib/modal/Modal';
import MarkdownComponent from './HOCs/Markdown';

export interface ChecklistItemInfo {
    title: string;
    description: string;
}

interface ChecklistItemAdditionalInfoModalProps {
    isVisible: boolean;
    title: string;
    description: string;
    onCancel: () => void;
    afterClose: () => void;
}

const ChecklistItemAdditionalInfoModal = (props: ChecklistItemAdditionalInfoModalProps) => {
    const { isVisible, title, description, onCancel, afterClose } = props;
    return (
        <Modal
            open={isVisible}
            onCancel={onCancel}
            afterClose={afterClose}
            width="70%"
            style={{ minWidth: 500, maxWidth: 800 }}
            footer={null}
            title={
                <Paragraph ellipsis={{ rows: 2 }} strong>
                    {title}
                </Paragraph>
            }
        >
            <MarkdownComponent source={description} />
        </Modal>
    );
};

export default ChecklistItemAdditionalInfoModal;
